import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import './chatHelpCardGridXA3.scss';
import { withStyles } from "@material-ui/core";
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import { Locate } from './chatHelp-IconsXA3/Locate';
import { TVTroubleshooting } from './chatHelp-IconsXA3/TVTroubleshooting';
import { XfinityVoice } from './chatHelp-IconsXA3/XfinityVoice';
import { Network } from './chatHelp-IconsXA3/Network';
import { VoiceRemote } from './chatHelp-IconsXA3/VoiceRemote';
import { XfinityHome } from './chatHelp-IconsXA3/XfinityHome';
import { MobileSupport } from './chatHelp-IconsXA3/MobileSupport';
import { Password } from './chatHelp-IconsXA3/Password';
import { Support } from './chatHelp-IconsXA3/Support';
import { Arrow } from './chatHelp-IconsXA3/Arrow';

const styles = () => ({
  title: {
    width: '100%'
  }
});

class chatHelpCardGridXA3 extends Component {


  constructor(props) {
    super(props);
    this.onGridKeyClicked = this.onGridKeyClicked.bind(this);
    this.onGridItemClicked = this.onGridItemClicked.bind(this);
  }

  renderImages(card, height, padding, width) {
    switch (card.icon) {

      case "Billing":
        return <Locate height={height} padding={padding} width={width} />;
      case "RemotePairing":
        return <VoiceRemote height={height} padding={padding} width={width} />;
      case "TV":
        return <TVTroubleshooting height={height} padding={padding} width={width} />;
      case "Voice":
        return <XfinityVoice height={height} padding={padding} width={width} />;
      case "XAIcon":
        return <XAIcon height={height} padding={padding} width={width} />;
      case "ForgotUserNamePassword":
        return <Password height={height} padding={padding} width={width} />;
      case "Internet":
        return <Network height={height} padding={padding} width={width} />;
      case "XfinityMobile":
        return <MobileSupport height={height} padding={padding} width={width} />;
      case "AppSupport":
        return <Support height={height} padding={padding} width={width} />;
      case "Home":
        return <XfinityHome height={height} padding={padding} width={width} />;

    }
  }

  onGridKeyClicked(event, title) {

    if (event.keyCode === 13) {
      event.preventDefault();
      this.props.defaultEvent(title, 'intent');

    }
  }

  onGridItemClicked(event, card) {
    //this.props.defaultEvent( event.currentTarget.innerText,'intent');
    this.props.defaultEvent(event.currentTarget.getAttribute('value'), 'intent');
    //event.currentTarget.getAttribute('value')
  }
  render() {
    const cards = this.props.cards;
    return <Grid
      data-tracking='{"container":["xa-chat-help"]}'
      container
      direction="row"
      justify="center"
      className={'chatHelp-card-grid-container'}
      alignItems="center">
      <Grid item xs={12} className={'chatHelp-card-grid-xa3'}>
        <Hidden xsDown>
          <h3 role="text" aria-label={cards.cardHeading} tabIndex="-1" className="chatHelp-card-grid-title">{cards.cardHeading}</h3>
        </Hidden>
        <Hidden smUp>
          <h3 role="text" aria-label={cards.cardHeading} tabIndex="-1" className="chatHelp-card-grid-title-small">{cards.cardHeading}</h3>
        </Hidden>
        <Grid data-tracking-parent data-tracking='{"container":["xa-chat-help-cards"]}' container
          direction="row"
          spacing={16}
          justify="center"
          alignItems="center">
          {cards.cardItems.map((card, index) =>
            <Grid item tabIndex="0" role="link" data-tracking key={index} md={4} sm={6} xs={12} onKeyDown={(event) => { this.onGridKeyClicked(event, card.title, 'intent'); }} className={'chatHelp-card-grid-item-container'}>

              <Hidden xsDown>
                <Link data-tracking='{"container":["xa-chat-help-cards-web"]}' className={"link-wrapper"}>
                  <Paper className="chatHelp-card-grid-item" value={card.intent} onClick={(event) => { this.onGridItemClicked(event, card.title, 'intent'); }}>
                    <div className="iconDiv">
                      {this.renderImages(card, 76, 0)}
                    </div>
                    <br />
                    <br />
                    <span className={'chatHelp-card-grid-item-title'}>{card.title}<Arrow /></span>
                  </Paper>
                </Link>
              </Hidden>
              <Hidden smUp>
                <Paper className="chatHelp-card-grid-item-small-xa3" value={card.intent} onClick={(event) => { this.onGridItemClicked(event, card.title, 'intent'); }}>
                  <Link data-tracking='{"container":["xa-chat-help-cards-mobile"]}' className="link-wrapper">
                    <Grid container
                      direction="row"
                      justify="center"
                      alignItems="center">
                      <Grid item xs={4}>
                        {this.renderImages(card, 76, 12, 93)}
                      </Grid>
                      <Grid item xs={8} container
                        direction="column"
                        justify="center"
                      >
                        <Grid item xs={12} className={'title-container'}>
                          <span className={'chatHelp-card-grid-item-title-small'}>{card.title}<Arrow /></span>
                        </Grid>

                      </Grid>
                    </Grid>
                  </Link>
                </Paper>

              </Hidden>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>;
  }
}

export default withStyles(styles)(chatHelpCardGridXA3);
